"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const driver_1 = require("services/master-data/driver");
const driver_types_1 = require("./driver.types");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, driver_1._getDriverData)(dataStates);
    if (response.isError) {
        const payload = {
            isError: response.isError,
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
        };
        dispatch({ type: driver_types_1.driverTypes.SET_ERROR, payload: payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError ? [] : response.data.map(item => {
                return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
            })
        };
        dispatch({ type: driver_types_1.driverTypes.SET_DATA_GRID, payload: payload });
    }
});
const onDataStateChange = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const payload = { dataStates };
    dispatch({ type: driver_types_1.driverTypes.ON_PAGE_CHANGE, payload });
});
const onClickMutation = (payload) => dispatch => {
    dispatch({ type: driver_types_1.driverTypes.ON_MUTATION_CLICK, payload });
};
const onSaveDataItem = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode, dataItem } = payload;
    const response = mutationMode === 'add'
        ? yield (0, driver_1._postDriverData)({
            driver: dataItem.driver,
            emp_no: dataItem.emp_no,
            is_active: dataItem.is_active,
            contractor: dataItem.contractor_code
        })
        : yield (0, driver_1._putDriverData)({
            id: dataItem.id,
            driver: dataItem.driver,
            emp_no: dataItem.emp_no,
            is_active: dataItem.is_active,
            contractor: dataItem.contractor_code
        });
    if (response.isError) {
        dispatch({
            type: driver_types_1.driverTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            }
        });
    }
    else {
        dispatch({
            type: driver_types_1.driverTypes.ON_SAVE_DATAITEM,
            payload: {
                dataItem,
                mutationMode,
                isSuccess: true
            }
        });
    }
});
const onGetDataContractor = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, driver_1._getContractorData)();
    if (response.isError) {
        dispatch({
            type: driver_types_1.driverTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: 'Error Fetching Contractor Data. \n'.concat(response.errorMessage),
            }
        });
    }
    else {
        dispatch({ type: driver_types_1.driverTypes.SET_DATA_CONTRACTOR, payload: response.data });
    }
});
const onDeleteDataItem = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const { mutationMode, dataItem } = payload;
    const response = yield (0, driver_1._deleteDriverData)({ id: dataItem.id });
    if (response.isError) {
        dispatch({
            type: driver_types_1.driverTypes.SET_ERROR,
            payload: {
                isError: response.isError,
                errorCode: response.errorCode,
                errorMessage: response.errorMessage,
            }
        });
    }
    else {
        dispatch({
            type: driver_types_1.driverTypes.ON_DELETE_DATAITEM,
            payload: {
                dataItem,
                mutationMode,
                isSuccess: !response.isError
            }
        });
    }
});
const onFilterChange = payload => dispatch => {
    dispatch({ type: driver_types_1.driverTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = payload => dispatch => {
    dispatch({ type: driver_types_1.driverTypes.ON_SORT_CHANGE, payload });
};
const onCloseError = () => dispatch => {
    dispatch({
        type: driver_types_1.driverTypes.SET_ERROR,
        payload: {
            errorCode: 0,
            errorMessage: '',
            isError: false
        }
    });
};
const onLoading = () => dispatch => {
    dispatch({ type: driver_types_1.driverTypes.SET_LOADING, payload: true });
};
exports.default = {
    getDataGrid,
    onSaveDataItem,
    onClickMutation,
    onDeleteDataItem,
    onDataStateChange,
    onGetDataContractor,
    onFilterChange,
    onSortChange,
    onCloseError,
    onLoading
};
